module.exports = __webpack_public_path__ + "img/logo.0756bc13.png";